import { Button } from "../buttonsLibrary";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { GambleColorBtn } from "../GambleGame/gambleBtn";

export class MobileFloatingButtons {
  private parentContainer: PIXI.Container;
  private btnContainer: PIXI.Container;
  private playBtnIcon: PIXI.Sprite;
  private playAutoIcon: PIXI.Sprite;
  private playGambleIcon: PIXI.Sprite;
  private playBtn: Button;
  private autoBtn: Button;
  private playGambleBtn: Button;
  private autoPlayLabel: PIXI.Text;
  private gambleLabel: PIXI.Text;
  private activeGameData: CommonData;
  private playTexture: Array<PIXI.Texture>;
  private collectLabel: PIXI.Text;
  private autoPlayBtnTweenSpin: PIXI.tween.Tween;
  private autoplayStopLabel: PIXI.Sprite;
  private desaturateMatrix: PIXI.filters.ColorMatrixFilter;
  private gambleBtnRed: GambleColorBtn;
  private gambleBtnBlack: GambleColorBtn;
  private stickyPosForStakePopup: number;
  private canvas: HTMLCanvasElement;

  private gameOrientationPortrait: boolean;
  private gamePortraitLogo: PIXI.Sprite;

  constructor(parentContainer: PIXI.Container, activeGameData: CommonData) {
    this.parentContainer = new PIXI.Container();
    this.btnContainer = new PIXI.Container();
    this.activeGameData = activeGameData;
    // this.parentContainer.scale.set(.5)

    this.gameOrientationPortrait = false;
    this.stickyPosForStakePopup = 0;
    this.canvas = document.getElementsByTagName("canvas")[0];
    this.playBtnIcon = new PIXI.Sprite(
      PIXI.Texture.fromImage("btn_PlayM_0.png")
    );
    this.playAutoIcon = new PIXI.Sprite(
      PIXI.Texture.fromImage("btn_AutoplayM.png")
    );
    this.playGambleIcon = new PIXI.Sprite(
      PIXI.Texture.fromImage("btnGamble_M.png")
    );

    this.playBtn = new Button(this.playBtnIcon, new PIXI.Circle(0, 0, 130));
    // this.playBtn.setOffScale();
    this.autoBtn = new Button(this.playAutoIcon, new PIXI.Circle(0, 0, 75));
    this.playGambleBtn = new Button(
      this.playGambleIcon,
      new PIXI.Circle(0, 0, 130)
    );

    this.playBtn.setPosition([0, this.activeGameData.size[1] / 2]);

    if (this.activeGameData.enableAutoPlayButton) {
      this.autoBtn.setPosition([0, this.playBtn.getPosition()[1] + 220]);
    }

    this.playGambleBtn.setPosition([0, this.playBtn.getPosition()[1] - 220]);

    this.parentContainer.addChild(this.btnContainer);

    this.btnContainer.addChild(this.playBtn.getImage());
    if (this.activeGameData.enableAutoPlayButton) {
      this.btnContainer.addChild(this.autoBtn.getImage());
    }

    this.btnContainer.addChild(this.playGambleBtn.getImage());

    this.gambleBtnRed = new GambleColorBtn(
      0,
      this.activeGameData,
      this.btnContainer
    );
    this.gambleBtnBlack = new GambleColorBtn(
      1,
      this.activeGameData,
      this.btnContainer
    );
    this.gambleBtnRed.setScale(0);
    this.gambleBtnBlack.setScale(0);

    if (this.activeGameData.isTableGame == false) {
      parentContainer.addChild(this.parentContainer);
    }

    this.playTexture = [];
    this.playTexture[0] = PIXI.Texture.fromImage("btn_PlayM_0.png");
    this.playTexture[1] = PIXI.Texture.fromImage("btn_PlayM_1.png");
    this.playTexture[2] = PIXI.Texture.fromImage("btn_PlayM_2.png");

    // let hitbox:PIXI.Graphics= new PIXI.Graphics;
    // hitbox.beginFill(0xff0000);
    // hitbox.alpha=.5
    // hitbox.drawCircle(0, 0, 130);
    // hitbox.endFill();
    // this.playBtn.image.addChild(hitbox)

    // let hitbox:PIXI.Graphics= new PIXI.Graphics;
    // hitbox.beginFill(0xff0000);
    // hitbox.drawRect(-185/2, -200, 185,400);
    // hitbox.endFill();
    // this.playBtn.image.addChild(hitbox)
    this.parentContainer.x = parentContainer.width - this.playBtn.getWidth(); //this.parentContainer.width;
    this.parentContainer.y = 105;
    this.autoPlayLabel = new PIXI.Text("x0", {
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 45,
      fill: ["#ffffff"],
      fontWeight: "bold",
      lineHeight: 45,
      stroke: 0x000000,
      strokeThickness: 10,
    });
    this.gambleLabel = new PIXI.Text(activeGameData.gameTextGeneral.gamble, {
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 35,
      fill: ["#ffffff"],
      fontWeight: "bold",
    });
    this.collectLabel = new PIXI.Text(activeGameData.gameTextGeneral.collect, {
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 45,
      fill: ["#ffffff"],
      fontWeight: "bold",
    });

    if (this.activeGameData.isMobile === false) {
      this.parentContainer.alpha = 0;
    }

    let playBtnImg = this.playBtn.getImage();
    let gambleBtnImg = this.playGambleBtn.getImage();
    let autoplayImg = this.autoBtn.getImage();
    if (this.activeGameData.enableAutoPlayButton) {
      this.btnContainer.addChild(this.autoPlayLabel);
    }
    if (this.gambleLabel.width > gambleBtnImg.width - 20) {
      this.gambleLabel.width = gambleBtnImg.width - 20;
      this.gambleLabel.scale.y = this.gambleLabel.scale.x;
    }
    if (this.collectLabel.width > playBtnImg.width - 20) {
      this.collectLabel.width = playBtnImg.width - 20;
      this.collectLabel.scale.y = this.collectLabel.scale.x;
    }

    gambleBtnImg.addChild(this.gambleLabel);
    playBtnImg.addChild(this.collectLabel);

    this.autoPlayLabel.x = autoplayImg.x - this.autoPlayLabel.width / 2;
    this.autoPlayLabel.y = autoplayImg.y - this.autoPlayLabel.height / 2;
    this.gambleLabel.anchor.set(0.5);
    // this.gambleLabel.rotation=-Math.PI/2;
    this.gambleLabel.y = 0;
    // this.gambleLabel.y= this.gambleLabel.height/2;
    // this.gambleLabel.x= +this.gambleLabel.width/2;
    this.collectLabel.anchor.set(0.5);
    // this.collectLabel.rotation=-Math.PI/2
    this.collectLabel.y = 0;
    // this.collectLabel.x= -this.collectLabel.width/2;
    this.collectLabel.alpha = 0;

    this.autoPlayBtnTweenSpin = PIXI.tweenManager.createTween(autoplayImg);
    this.autoPlayBtnTweenSpin
      .from({ rotation: autoplayImg.rotation })
      .to({ rotation: autoplayImg.rotation + ((360 * Math.PI) / 180) * -1 });
    this.autoPlayBtnTweenSpin.time = 3000;
    this.autoPlayBtnTweenSpin.easing = PIXI.tween.Easing.linear();
    this.autoPlayBtnTweenSpin.loop = true;
    this.autoPlayBtnTweenSpin.stop();

    this.autoplayStopLabel = new PIXI.Sprite(
      PIXI.Texture.fromFrame("btn_stop.png")
    );
    this.autoplayStopLabel.anchor.set(0.5);
    this.autoplayStopLabel.scale.set(1.5);
    this.autoplayStopLabel.x = this.autoBtn.getPosX(); // - this.autoPlayCounts.width / 2;;
    this.autoplayStopLabel.y = this.autoBtn.getPosY() + 45; //- this.autoPlayCounts.height / 2;
    this.btnContainer.addChild(this.autoplayStopLabel);
    this.autoplayStopLabel.alpha = 0;

    this.desaturateMatrix = new PIXI.filters.ColorMatrixFilter();

    playBtnImg.filters = null; //[this.desaturateMatrix];
    // playBtnImg.filterArea=new PIXI.Rectangle(0,0,1920,1080)
    this.desaturateMatrix.desaturate();

    //---logo for portrait mode
    let topParent = this.activeGameData.portraitModeBackground.getLogoContainer();
    this.gamePortraitLogo = new PIXI.Sprite(
      PIXI.Texture.fromFrame("LOGOS_english.png")
    );

    topParent.addChild(this.gamePortraitLogo);
    this.gamePortraitLogo.anchor.set(0.5, 0);
    this.gamePortraitLogo.y = 10; //this.gamePortraitLogo.height/2;
    this.gamePortraitLogo.x = this.activeGameData.size[0] / 2;
    let originalHeight = this.gamePortraitLogo.height;

    let maxHeight = 200; //--logo max height for portrait logo
    if (this.activeGameData.isDemo) {
      maxHeight = 200 * 1.2;
    }
    let newScale = maxHeight / originalHeight;
    this.gamePortraitLogo.scale.set(newScale);
  }
  public setNewTexturePlayBtn = (
    texturenames: Array<string>,
    index: number
  ): void =>
    // ['play','skip','collect']
    {
      this.playTexture = [];
      this.playTexture[0] = PIXI.Texture.fromImage(texturenames[0] + ".png");
      this.playTexture[1] = PIXI.Texture.fromImage(texturenames[1] + ".png");
      this.playTexture[2] = PIXI.Texture.fromImage(texturenames[2] + ".png");
      this.playBtnIcon.texture = PIXI.Texture.fromImage(
        texturenames[0] + ".png"
      );
      this.playAutoIcon.texture = PIXI.Texture.fromImage(
        texturenames[3] + ".png"
      );
      this.playGambleIcon.texture = PIXI.Texture.fromImage(
        texturenames[4] + ".png"
      );
      ///-update the texture
      this.setplayBtnMode(index);
    };
  public getPortraitLogo = (): PIXI.Sprite => {
    return this.gamePortraitLogo;
  };
  public getPlayBtnSprite = (): PIXI.Sprite => {
    return this.playBtn.getImage();
  };
  private alignementPortrait = (bool: boolean): void => {
    this.gameOrientationPortrait = bool;
    this.activeGameData.isInPortraitMode = bool;

    if (bool) {
      this.playBtn.setPosition([-8, this.stickyPosForStakePopup / 3 + 100]); //this.activeGameData.mobilePortraitBG.height-this.activeGameData.size[0]]);
      this.autoBtn.setPosition([-220 - 16, this.playBtn.getPosition()[1]]);
      this.playGambleBtn.setPosition([220 + 8, this.playBtn.getPosition()[1]]);
      //gamble visible
      this.gambleBtnRed.setPosition([
        this.playBtn.getPosX() - 150,
        this.playBtn.getPosY() - 200,
      ]);
      this.gambleBtnBlack.setPosition([
        this.playBtn.getPosX() + 150 + 15,
        this.playBtn.getPosY() - 200,
      ]);
      if (this.activeGameData.enableNewGambleGameFromNico === false) {
        this.gambleBtnRed.setScale(0.9);
        this.gambleBtnBlack.setScale(0.9);
      }
    } else {
      this.playBtn.setPosition([0, this.activeGameData.size[1] / 2]);
      this.autoBtn.setPosition([0, this.playBtn.getPosition()[1] + 220]);
      this.playGambleBtn.setPosition([0, this.playBtn.getPosition()[1] - 220]);

      this.gambleBtnRed.setPosition([0, 0]);
      this.gambleBtnBlack.setPosition([0, 0]);
      this.gambleBtnRed.setScale(0);
      this.gambleBtnBlack.setScale(0);
    }

    this.autoplayStopLabel.x = this.autoBtn.getPosX(); // - this.autoPlayCounts.width / 2;;
    this.autoplayStopLabel.y = this.autoBtn.getPosY() + 45; //- this.autoPlayCounts.height / 2;
    // let autoplayImg= this.autoBtn.getImage()
    this.autoPlayLabel.x =
      this.autoBtn.getPosX() - this.autoPlayLabel.width / 2;
    this.autoPlayLabel.y =
      this.autoBtn.getPosY() - this.autoPlayLabel.height / 2;
  };

  public setFunctionGambleBtn = (index: number, newFn: Function): void => {
    if (index == 0) {
      // set fn for red btn
      this.gambleBtnRed.setFunction(newFn);
    } else if (index == 1) {
      this.gambleBtnBlack.setFunction(newFn);
    }
  };
  public setGambleActive = (bool: boolean): void => {
    //set gray or not
    this.gambleBtnBlack.setActive(bool);
    this.gambleBtnRed.setActive(bool);
  };
  public setGambleVisible = (bool: boolean): void => {
    this.gambleBtnBlack.setVisible(bool);
    this.gambleBtnRed.setVisible(bool);
    // console.log(bool)
  };

  public setStyleNewBtnImage = (
    blackImage: string,
    RedImage: string,
    GrayImage: string,
    overlayAnimationName: string,
    animationTotalFrames: number = 22
  ): void => {
    this.gambleBtnRed.setNewStyle(
      blackImage,
      RedImage,
      GrayImage,
      overlayAnimationName,
      animationTotalFrames
    );
    this.gambleBtnBlack.setNewStyle(
      blackImage,
      RedImage,
      GrayImage,
      overlayAnimationName,
      animationTotalFrames
    );
  };

  public playGambleAnimation = (): void => {};

  public setGambleBtnClicked = (index: number): void => {
    if (index == 0) {
      this.gambleBtnRed.setClicked();
    } else if (index == 1) {
      this.gambleBtnBlack.setClicked();
    }
  };

  public setGambleHighLight = (index: number): void => {
    if (index == 0) {
      this.gambleBtnRed.playHighLight();
    } else if (index == 1) {
      this.gambleBtnBlack.playHighLight();
    }
  };

  public setPortraitMode = (): void => {
    // let canvas = document.getElementsByTagName('canvas')[0];

    let screenRatio = window.innerHeight / window.innerWidth;
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;

    if (
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      let newScale = 3; //2.3;
      this.btnContainer.scale.set(newScale); //608 height default
      this.alignementPortrait(true);
      let scaleMultiplier =
        this.activeGameData.size[1] / this.activeGameData.gameResolution[1];
      this.btnContainer.x = this.activeGameData.size[0] / 2;

      //center the btn---disan;ed
      // let pos0Btn=-(this.activeGameData.size[1]*(newScale/2))-this.activeGameData.size[1]-this.playBtn.getImage().height/2//*2+(155+this.activeGameData.portraitPlayOffsetTop)//*scaleMultiplier//-105-this.activeGameData.size[1]/2;
      // let center=((this.canvas.height)*scaleMultiplier)/2;
      // let offset=this.activeGameData.gameResolution[1]/2+this.activeGameData.portraitPlayOffsetTop/2-this.activeGameData.mobilePortraitUI.getParent().height/2
      // this.btnContainer.y=pos0Btn+center+offset;//vertical

      let posYZero =
        -this.activeGameData.size[1] -
        this.activeGameData.portraitPlayOffsetTop -
        600;
      // let stickToBtn=posYZero+(canvas.height)*scaleMultiplier-700;

      this.stickyPosForStakePopup =
        posYZero + this.canvas.height * scaleMultiplier - 700;
      // this.activeGameData.autoplayPopper.setNewPos([365, this.btnContainer.y+900]);//--

      // this.canvas.height/4+this.activeGameData.size[1] / 8]
      // this.activeGameData.autoplayPopper.setNewPos([600,this.canvas.height/4+this.activeGameData.size[1] / 8)]);//--

      this.activeGameData.autoplayPopper.setNewPos([
        600,
        this.activeGameData.mobilePortraitBG.height -
          this.activeGameData.size[0] / 2,
      ]); //--

      this.activeGameData.autoplayPopper.setVerticalView(true);
      this.activeGameData.betPopper.getParent().x = 0;
      this.activeGameData.betPopper.getParent().y = this.stickyPosForStakePopup;
      this.activeGameData.betPopper.setVerticalView(true);
      // console.log('setOFfset',  this.activeGameData.betPopper.getOffsetParent().y)
      this.activeGameData.gameBar.setbarvisible(false); //hide Default GameBar

      if (this.activeGameData.autoplayPopper.getIsOpen()) {
        this.onAutoplayOpenHidePlayBtnOnPortraitMode(true);
      }
    } else {
      this.alignementPortrait(false);
      this.btnContainer.scale.set(1);
      this.btnContainer.x = 0;
      this.btnContainer.y = 0;
      // this.btnContainer.x=this.activeGameData.size[0]/2;
      // this.activeGameData.autoplayPopper.getParent().scale.set(1)
      this.activeGameData.autoplayPopper.setNewPos([0, 0]);
      this.activeGameData.autoplayPopper.setVerticalView(false);
      // this.setAutoPlayMobileVisible(true);

      // this.activeGameData.betPopper.getParent().scale.set(1)///)=stickToBtn;
      this.activeGameData.betPopper.getParent().y = 0;
      this.activeGameData.betPopper.getParent().x = 0;
      this.activeGameData.betPopper.setVerticalView(false);
      // console.log('resetPos',  this.activeGameData.betPopper.getOffsetParent().y)
      this.activeGameData.gameBar.setbarvisible(true);
      this.onAutoplayOpenHidePlayBtnOnPortraitMode(false); //--disable on landscape mode
    }
  };
  public setPlayfn = (fn: Function): void => {
    // this.playBtn.image.on('pointertap', fn);
    this.playBtn.setFunction(fn);
  };
  public setAutoFn = (fn: Function): void => {
    this.autoBtn.setFunction(fn);
  };
  public setGambleFn = (fn: Function): void => {
    this.playGambleBtn.setFunction(fn.bind(undefined, this.activeGameData));
  };
  public setplayBtnMode = (playTexNum: number): void => {
    this.playBtn.getImage().filters = null;
    this.playBtn.setNewTexture(this.playTexture[playTexNum]);
    if (playTexNum === 2) {
      this.collectLabel.alpha = 1;
    } else {
      this.collectLabel.alpha = 0;
    }
  };

  public onAutoplayOpenHidePlayBtnOnPortraitMode = (bool: boolean): void => {
    if (
      this.activeGameData.isMobile &&
      this.activeGameData.playOnPortrait &&
      this.gameOrientationPortrait
    ) {
      this.playBtn.hide(bool);
      this.playGambleBtn.hide(bool);
    } else {
      this.playBtn.hide(false);
      this.playGambleBtn.hide(false);
    }
  };

  // private resetPlayBtn=():void=>
  // {

  //     this.playBtn.hide(false);
  //     this.playGambleBtn.hide(false);

  // }
  public setBlackAndWhitePlay = (): void => {
    this.playBtn.getImage().filters = [this.desaturateMatrix];
  };

  public setMobileUIDisabled = (): void => {
    // this.playBtn.image.interactive = false;
    // this.autoBtn.image.interactive = false;
    // this.playGambleBtn.image.interactive = false;

    this.playBtn.setInteractive(false);
    this.autoBtn.setInteractive(false);
    this.playGambleBtn.setInteractive(false);

    this.playBtn.setAlpha(0);
    this.autoBtn.setAlpha(0);
    this.playGambleBtn.setAlpha(0);

    this.autoPlayLabel.alpha = 0;
  };
  public setAutoplayCount = (newAutoPlayCounter: number): void => {
    this.autoPlayLabel.text = "x" + newAutoPlayCounter;
    // this.autoPlayLabel.x = -this.autoPlayLabel.width / 2;

    this.autoPlayLabel.x =
      this.autoBtn.getPosX() - this.autoPlayLabel.width / 2;

    // if(this.activeGameData.playOnPortrait && this.activeGameData.isMobile)
    // {
    //     this.activeGameData.mobilePortraitUI.setAutoplayCount(newAutoPlayCounter)
    // }
  };
  public setAutoplayRotationTween = (spin: boolean): void => {
    if (spin) {
      this.autoPlayBtnTweenSpin.start();
      // this.autoplayStopLabel.alpha=1;
      if (
        this.activeGameData.betResponse.gameContext.contextData
          .bonusGameResult != undefined ||
        this.activeGameData.betResponse.gameContext.contextData.bonus
      ) {
        this.autoplayStopLabel.alpha = 0;
      } else {
        this.autoplayStopLabel.alpha = 1;
      }
    } else {
      this.autoPlayBtnTweenSpin.stop();
      this.autoPlayBtnTweenSpin.reset();
      this.autoplayStopLabel.alpha = 0;

      // if(this.activeGameData.playOnPortrait && this.activeGameData.isMobile)
      // {
      //     this.activeGameData.mobilePortraitUI.setSpinAutoPlay(false)
      // }
    }
  };
  public setHidden = (bool: boolean): void => {
    if (bool) {
      this.parentContainer.scale.set(0);
    } else {
      this.parentContainer.scale.set(1);
    }
  };
  public setButtonMode = (bool: boolean): void => {
    // let i = bool ? 1 : 0;
    if (this.activeGameData.isMobile) {
      this.playBtn.setInteractive(bool);
      this.autoBtn.setInteractive(bool);
      // if(this.activeGameData.replayMode==false)
      // {
      //     this.parentContainer.alpha = i;
      // }
    }
    // else
    // {
    //     this.playBtn.image.interactive = false;
    //     this.playBtn.image.buttonMode = false;
    //     this.autoBtn.image.interactive = false;
    //     this.autoBtn.image.buttonMode = false;
    //     this.parentContainer.alpha = 1
    // }
  };
  public getAutoplayBtn = (): Button => {
    return this.autoBtn;
  };
  public getParentContainer = (): PIXI.Container => {
    return this.parentContainer;
  };
  public getPlayButtonWidth = (): number => {
    return this.playBtn.getWidth();
  };
  public setGambleMode = (bool: boolean): void => {
    this.playGambleBtn.setInteractive(bool);
    let newAlpha = bool ? 1 : 0;
    this.playGambleBtn.setAlpha(newAlpha);
    this.gambleLabel.alpha = newAlpha;
  };

  public setVisibleOnlyGamble() {
    //makes it visibile yet unclickbale
    this.playGambleBtn.setAlpha(1);
    this.gambleLabel.alpha = 1;
    this.playGambleBtn.setInteractive(false);
  }

  public setGambleButtonMode = (bool: boolean): void => {
    this.playGambleBtn.setInteractive(bool);
  };

  // public setAutoPlayMobileVisible=(bool:boolean):void=>
  // {
  //     if(bool)
  //     {
  //         // this.aut
  //         this.autoBtn.getImage().scale.set(1);
  //         this.autoplayStopLabel.scale.set(1);
  //         // this.autoPlayLabel.scale.set(1);
  //         this.autoPlayLabel.alpha=1;
  //         // console.log('UNHIDE IT')

  //     }

  //     else
  //     {

  //         this.autoBtn.getImage().scale.set(0);
  //         this.autoplayStopLabel.scale.set(0);
  //         // this.autoPlayLabel.scale.set(0);
  //         this.autoPlayLabel.alpha=0;
  //         //  console.log('HIDE IT autoplay on portrait play on mobile')
  //     }
  // }
}
